import { getRolesNoPaging } from 'common/api/companies';

import {
    FETCH_ROLES,
    FETCH_ROLES_FAILURE,
    FETCH_ROLES_SUCCESS,
} from '../actionTypes';
import { companyUsersActions } from '../reducer';

export default (id) => (dispatch) => {
    dispatch(companyUsersActions[FETCH_ROLES]());

    getRolesNoPaging(id)
        .then((response) =>
            dispatch(
                companyUsersActions[FETCH_ROLES_SUCCESS](response.data.data),
            ),
        )
        .catch((error) =>
            dispatch(
                companyUsersActions[FETCH_ROLES_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
